import type { AnnouncementSummary } from "../../../hooks/useAdminAnnouncements";
import { countTiles } from "../../../lib/announcements";
import own from "./Announcements.module.css";

export const AnnouncementCounts = ({ summary }: { summary: AnnouncementSummary }): JSX.Element => (
  <div className={own.counts} data-testid="announcement-counts">
    {countTiles(summary).map((tile) => (
      <div key={tile.label} className={own.count}>
        <span className={`${own.countValue} ${tile.value > 0 ? (own[tile.tone] ?? "") : ""}`}>{tile.value}</span>
        {tile.label}
      </div>
    ))}
  </div>
);
